export default "__VITE_ASSET__c01c232b__"